import { ICategoryFormState } from '../types/CategoryForm';

export default (state: ICategoryFormState) => ({
    name: state.name || '',
    parentId: state.parentCategory?.id || 0,
    projectId: state.project?.id || 0,
    users: state.users?.map(user => user.id) || [],
});
